import { render } from "./PartnerCompany.vue?vue&type=template&id=51dbd871&scoped=true"
import script from "./PartnerCompany.vue?vue&type=script&lang=js"
export * from "./PartnerCompany.vue?vue&type=script&lang=js"

import "./PartnerCompany.vue?vue&type=style&index=0&id=51dbd871&scoped=true&lang=css"
import "./PartnerCompany.vue?vue&type=style&index=1&id=51dbd871&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51dbd871"]])

export default __exports__